
export const defaultPricingConfig = {
  widthOptions: {
    oneCar: 1,
    twoCars: 2,
    threeCars: 3,
    fourCars: 4,
    fiveCars: 5,
    moreThanFiveLessThanTen: 7,
    moreThanTenLessThanTwenty: 10,
  },
  lengthOptions: {
    oneCar: 1,
    twoCars: 2,
    threeCars: 3,
    fourCars: 4,
    fiveCars: 5,
    footballField: 7,
    twoFootballFields: 8.5,
    moreThanTwoFootballFields: 10,
  },
  depthOptions: {
    '0To6': {
      min: 35,
      max: 140,
    },
    '6To12': {
      min: 41,
      max: 180,
    },
    moreThan12: {
      min: 51,
      max: 200,
    },
  },
  addons: {
    stake: 25,
    citySidewalkShovel: 15,
    northWalkwayShovel: 6,
    southWalkwayShovel: 6,
    eastWalkwayShovel: 6,
    westWalkwayShovel: 6,
    citySidewalkSalt: 6,
    northWalkwaySalt: 5,
    southWalkwaySalt: 5,
    eastWalkwaySalt: 5,
    westWalkwaySalt: 5,
  },
};

export const appStrings = {
  additionalServices: {
    stake: 'Staking',
    citySidewalkShovel: 'City Sidewalk Shovel',
    northWalkwayShovel: 'North Walkway Shovel',
    southWalkwayShovel: 'South Walkway Shovel',
    eastWalkwayShovel: 'East Walkway Shovel',
    westWalkwayShovel: 'West Walkway Shovel',
    citySidewalkSalt: 'City Sidewalk Salt',
    northWalkwaySalt: 'North Walkway Salt',
    southWalkwaySalt: 'South Walkway Salt',
    eastWalkwaySalt: 'East Walkway Salt',
    westWalkwaySalt: 'West Walkway Salt',
  },
  drivewayDetails: {
    length: {
      oneCar: 'One Car',
      twoCars: 'Two Cars',
      threeCars: 'Three Cars',
      fourCars: 'Four Cars',
      fiveCars: 'Five Cars',
      footballField: 'About the length of a football field',
      twoFootballFields: 'About two football fields',
      moreThanTwoFootballFields: 'More than two football fields',
    },
    width: {
      oneCar: 'One Car',
      twoCars: 'Two Cars',
      threeCars: 'Three Cars',
      fourCars: 'Four Cars',
      fiveCars: 'Five Cars',
      moreThanFiveLessThanTen: 'More than five cars, less than ten cars wide',
      moreThanTenLessThanTwenty: 'More than ten cars, less than twenty cars wide',
    },
    shape: {
      straight: 'Straight',
      curvy: 'Curvy',
      horseshoe: 'Horseshoe',
    },
    surface: {
      paved: 'Paved',
      dirt: 'Dirt',
      gravel: 'Gravel',
    },
  },
  addressDetails: {
    type: {
      residential: 'Residential',
      commercial: 'Commercial',
    },
  },
  requestDetails: {
    snowDepth: {
      '0To6': '0" to 6"',
      '6To12': '6" to 12"',
      moreThan12: 'More than 12"',
    },
  },
  faqData: {
    customerFaq: [
      {
        title: 'Why should I use QUIKPLOW?',
        content: 'QUIKPLOW allows flexibility in your plowing needs. There’s no contracts needed! You can order a QUIKPLOW on a whim, when you’re sick, when you’re out of town, when its too cold outside, or when you want to help out friends or family.',
      },
      {
        title: 'What services can I request?',
        content: 'When logging onto the app you will see the options we offer, such as driveway clearing, side walk shoveling, and salting. All you need to do is select the service you would like and QUIKPLOW will send a certified contractor to complete the job.',
      },
      {
        title: 'How fast can I expect the snow removal service?',
        content: 'If you have a specific time you need a plow to be there (e.g., before 8 a.m.) you can specify that in the comments section and we will do our best to accommodate requests. Otherwise, you will be given an ETA and be able to track your contractor. Snowplow drivers and shovelers are expected to work in severe snow storms but inclement weather may delay services.',
      },
      {
        title: 'Do I need to be home during snow removal service?',
        content: 'No, you do not need to be home for QUIKPLOW to perform services. You will receive a picture from your contractor once the job is complete.',
      },
      {
        title: 'Do I need a contract?',
        content: 'What makes QUIKPLOW so great is that no contracts are required! QUIKPLOW can be ordered only when needed.',
      },
      {
        title: 'How are contractors selected?',
        content: 'We select high quality contractors as reflected in our requirements. We ensure our snowplow drivers are certified, insured, over 18 years of age, and can pass an online background check. Our shovelers are certified and over 18 years of age and can pass an online background check.',
      },
      {
        title: 'What happens if I’m not satisfied with my service?',
        content: 'QUIKPLOW finds certified and reliable contractors and tries to ensure the highest quality service. If a contractor doesn’t meet your needs, please contact QUIKPLOW and we will do everything we can to guarantee your satisfaction with our services.',
      },
      {
        title: 'How can I communicate with the contractor?',
        content: 'Once a contractor accepts your job, you will be notified and able to message them through the app.',
      },
      {
        title: 'Can I order snow removal for someone else?',
        content: 'Yes! The beauty of using the QUIKPLOW app, is it allows you to order snow plowing service for friends and family who might be in need.',
      },
      {
        title: 'How accurate are the estimated costs for service?',
        content: 'Your estimated price will be the cost for service as long as the contractor confirms the amount of snow fall and driveway size.',
      },
      {
        title: 'I do not see any contractors in my area?',
        content: 'There might be two reasons for this. 1) We are still actively growing and looking for new customers and contractors. Check back in a few weeks to see if we have reached your area. 2) You can only see if a contractor when they are actively using an app, so check back when there is a snow storm!',
      },
      {
        title: 'How do I pay my contractor?',
        content: 'You will enter your credit card information when signing up on the QUIKPLOW app. Contractors take before and after pictures of the driveway. Once your job is completed, your credit card will be charged safely and securely. All credit card and bank information is stored with a third party company called STRIPE, QUIKPLOW does not have access to that data.',
      },
      {
        title: 'Who is responsible for supplying salt when it is requested?',
        content: 'The service provider is responsible for providing the salt.',
      },
    ],
    providerFaq: [
      {
        title: 'Why should I use QUIKPLOW?',
        content: 'If you are looking for an easy way to make money without having to do the legwork to find new business, QUIKPLOW is for you! We find the work for you, there are no invoices, or tracking customers for payment. As a contractor you would be able to work as much or as little as you would like without a contract.',
      },
      {
        title: 'What requirements do I need to be a QUIKPLOW snowplow driver?',
        content: 'Plowers will need to pass an online background check. Be at least 18 years old. Submit proper liablility insurance obtained for your plow service. Have a valid US driver’s license. Submit a picture of yourself. Submit picture of truck and plow',
      },
      {
        title: 'What requirements do I need to be a QUIKPLOW shoveler?',
        content: 'Shovelers will need to pass an online background check. Be at least 18 years old. Have a valid US driver’s license. Submit picture of yourself. Have shovel or snowblower and reliable transportation',
      },
      {
        title: 'What is the payment method?',
        content: 'We ask for your banking information to send the payment safely and securely into your account 7-10 days after a job is completed.',
      },
      {
        title: 'How will I get jobs?',
        content: 'You will first need to sign up through the website or app and complete the application to be a contractor with QUIKPLOW. Once your application is reviewed and approved you will get an email notification to complete the hiring process. To start working you will log into the app and be able to see and select jobs in your area. Once you select a job, you will receive a confirmation notice and you can begin working!',
      },
      {
        title: 'What happens if the driveway is larger than the customer reported?',
        content: 'We trust our customers but understand that under/over estimates can happen and if that the case, please take a picture and send us an email. We will work with the customer directly to make things right.',
      },
      {
        title: 'Do I need a snow plow to work for QUIKPLOW?',
        content: 'If you are a snowplow driver, you will be required to have your own snowplow and vehicle. If you are a shoveler, you will be required to have a shovel.',
      },
    ],
  },
};
